import styled from 'styled-components';

export const SectionTitle = styled.h1`
  font-family: 'Montserrat SemiBold';
  font-size: 28px;
  line-height: 39px;
  font-weight: 600;
  font-style: normal;
  color: var(--grey-95, #0C0D0D);  
`;

export const SmallTitleRegular = styled.h2`
  font-family: 'Montserrat Regular';
  font-size: 21px;
  line-height: 28px;
  font-weight: 400;
  font-style: normal;
  color: var(--grey-95, #0C0D0D);  
`;

export const SmallTitleSemiBold = styled.h2`
  font-family: 'Montserrat SemiBold';
  font-size: 21px;
  line-height: 28px;
  font-weight: 600;
  font-style: normal;
  color: var(--grey-95, #0C0D0D);  
`;

export const HighlightMedium = styled.span`
  font-family: 'Montserrat Medium';
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  font-style: normal;
  color: var(--grey-95, #0C0D0D);  
`;

export const HighlightBold = styled.span`
  font-family: 'Montserrat Bold';
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  font-style: normal;
  color: var(--grey-95, #0C0D0D);  
`;

export const BodyTextRegular = styled.p`
  font-family: 'Montserrat Regular';
  font-size: 14px;
  line-height: 19px;
  font-weight: 400;
  font-style: normal;
  color: var(--grey-95, #0C0D0D);  
`;

export const BodyTextMedium = styled.p`
  font-family: 'Montserrat Medium';
  font-size: 14px;
  line-height: 19px;
  font-weight: 500;
  font-style: normal;
  color: var(--grey-95, #0C0D0D);  
`;

export const BodyTextSemiBold = styled.p`
  font-family: 'Montserrat SemiBold';
  font-size: 14px;
  line-height: 19px;
  font-weight: 600;
  font-style: normal;
  color: var(--grey-95, #0C0D0D);  
`;

export const BodyTextBold = styled.p`
  font-family: 'Montserrat Bold';
  font-size: 14px;
  line-height: 19px;
  font-weight: 700;
  font-style: normal;
  color: var(--grey-95, #0C0D0D);  
`;

export const FootnoteLight = styled.small`
  font-family: 'Montserrat Light';
  font-size: 12px;
  line-height: 16px;
  font-weight: 300;
  font-style: normal;
  color: var(--grey-95, #0C0D0D);  
`;

export const FootnoteRegular = styled.small`
  font-family: 'Montserrat Regular';
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  font-style: normal;
  color: var(--grey-95, #0C0D0D);  
`;

export const FootnoteMedium = styled.small`
  font-family: 'Montserrat Medium';
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  font-style: normal;
  color: var(--grey-95, #0C0D0D);  
`;

export const FootnoteSemiBold = styled.small`
  font-family: 'Montserrat SemiBold';
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  font-style: normal;
  color: var(--grey-95, #0C0D0D);  
`;

export const SelectionChip = styled.span`
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background: var(--grey-10, #E4E5E7);
  margin: 4px;
  color: var(--grey-95, #0C0D0D);
  font-size: 14px;
  max-width: 100%;
  overflow: hidden;
  word-break: break-all;
`;

export const ModalText = styled.p`
 color: var(--grey-50, #797E86);
text-align: center;
font-family: 'Montserrat Regular';
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 19px; /* 135.714% */
`;
export const ModalTextLeft = styled.p`
 color: var(--grey-50, #797E86);
text-align: left;
font-family: 'Montserrat Regular';
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 19px; /* 135.714% */
`;